import { useQuery, useQueryClient } from "@tanstack/react-query";
import { logoutUser } from "@/lib/queryClient";

export const AUTH_TOKEN_KEY = ["authToken"];

export function useAuthToken() {
  const queryClient = useQueryClient();

  const { data: token } = useQuery<string | null>({
    queryKey: AUTH_TOKEN_KEY,
    queryFn: () => {
      return localStorage.getItem("token") || null;
    },
    staleTime: Infinity,
    initialData: () => {
      return localStorage.getItem("token") || null;
    },
  });

  const setToken = (
    newToken: string | null,
    newRefreshToken?: string | null
  ) => {
    if (newToken) {
      localStorage.setItem("token", newToken);
      if (newRefreshToken) {
        localStorage.setItem("refreshToken", newRefreshToken);
      }
      queryClient.setQueryData(AUTH_TOKEN_KEY, newToken);
    } else {
      logoutUser();
    }
  };

  const logout = () => {
    logoutUser();
  };

  return {
    token,
    isAuthenticated: Boolean(token),
    setToken,
    logout,
  };
}
